import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import ExpansionPanel from '@/views/components/ExpansionPanel.vue';
import { mdiFilterVariant } from '@mdi/js';
import FiltroOrdenacao from '@/views/components/FiltroOrdenacao.vue';
import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';
import CardResultado from './CardResultado.vue';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import { storeToRefs } from 'pinia';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';
import AlertCard from '@/views/components/AlertCard.vue';
import {
  contemNaLista,
  isTodosSelecionados,
  selecionarTodos,
  toggleSelecionado,
} from '@/utils/ListUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultadoConsulta',
  setup(__props) {

const store = ConsultaLegislacaoStore();

const {
  pageSubfiltros,
  legisnormas,
  totalElementos,
  dataOptions,
  totalHits,
  filtroLegislacao,
  legisnormasSelecionadas,
} = storeToRefs(store);

const { atualizarPaginacao, atualizarOrdenacao, consultaListaLegislacao } =
  store;

const resultadoConsulta = ref();

const ordenacaoSelecionada = computed(() => {
  return ordenacaoItems.value?.find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (el: any) => el.value == filtroLegislacao.value.ordenacao
  );
});

const limparFiltrosResultado = () => {
  pageSubfiltros.value?.forEach((filtro) =>
    filtro?.valoresSubFiltroResponseDTO?.forEach(
      (subFiltro) => (subFiltro.checked = false)
    )
  );
};

const ordenacaoItems = computed(() => {
  return store.pageLegislacao.ordenacoes?.map((item) => ({
    text: item.label,
    value: item.value,
  }));
});

const itensImpressao = [
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
  {
    text: 'Texto da norma',
    value: 'T',
    icone: IconTextoNorma,
  },
];

return { __sfc: true,store, pageSubfiltros, legisnormas, totalElementos, dataOptions, totalHits, filtroLegislacao, legisnormasSelecionadas, atualizarPaginacao, atualizarOrdenacao, consultaListaLegislacao, resultadoConsulta, ordenacaoSelecionada, limparFiltrosResultado, ordenacaoItems, itensImpressao, ExpansionPanel, mdiFilterVariant, FiltroOrdenacao, SeletorOpcoesImpressão, CardResultado, AlertCard, contemNaLista, isTodosSelecionados, selecionarTodos, toggleSelecionado }
}

})